/**
 * Client-side Microsoft Graph API hook.
 */
import { useSession } from 'next-auth/react';
import { SWRConfiguration } from 'swr';
import useSWRImmutable from 'swr/immutable';

import { apiScopes } from '../../api/apiScopes';
import { jsonFetcher } from '../../api/ownApi/fetcher';
import { useScopedAPIToken } from '../../api/useScopedAPIToken';

const GRAPH_API_BASE_URL = 'https://graph.microsoft.com/v1.0';

export const useGraphApi = <T>(path: string, swrConfig?: SWRConfiguration) => {
	const { data: session } = useSession();
	const { token, isTokenLoading } = useScopedAPIToken([apiScopes.graph.group_read_all]);
	const canFetch = Boolean(session && !session.isTestUser && token && !isTokenLoading);
	const url = `${GRAPH_API_BASE_URL}${path}`;

	return useSWRImmutable<T>(
		canFetch ? [url, token] : null,
		async ([fetchUrl, fetchToken]: [string, string]) => {
			return jsonFetcher<T>(fetchUrl, {
				headers: { Authorization: `Bearer ${fetchToken}` },
			});
		},
		swrConfig,
	);
};
